import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  useNavigate,
  useLocation,
} from "react-router-dom";
import Card from "../components/Card";
//import FloatingMenu from "../components/FloatingMenu";

function GradePage() {
  const navigate =
    useNavigate();

  const location =
    useLocation();

  const flowType =
    location.state?.feature?.route ||
    localStorage.getItem("feature_route") ||
    localStorage.getItem("flow_type") ||
    "mcq";

      console.log("FLOW TYPE =", flowType);
      console.log("LOCATION STATE =", location.state);


  const [grades, setGrades] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  /* ================= LOAD GRADES ================= */

  useEffect(() => {
    loadGrades();
  }, []);

  const loadGrades =
    async () => {
      try {
        const res =
          await axios.get(
            "https://edunet.kmechengineering.com/root-engine1/api/grades"
          );

        setGrades(
          res.data.grade_data || []
        );
      } catch (error) {
        console.log(error);
        setGrades([]);
      } finally {
        setLoading(false);
      }
    };

  /* ================= NAVBAR HIDE / TOP SHOW ONLY ================= */

  useEffect(() => {
    const navbar =
      document.querySelector(
        ".navbar"
      );

    const handleScroll =
      () => {
        const currentScroll =
          window.pageYOffset;

        if (!navbar) return;

        /* top show */
        if (
          currentScroll <= 10
        ) {
          navbar.style.transform =
            "translateX(-50%) translateY(0)";
          navbar.style.opacity =
            "1";
        }

        /* scroll hide */
        else {
          navbar.style.transform =
            "translateX(-50%) translateY(-130%)";
          navbar.style.opacity =
            "0";
        }
      };

    if (navbar) {
      navbar.style.position =
        "fixed";
      navbar.style.top =
        "15px";
      navbar.style.left =
        "50%";
      navbar.style.width =
        "90%";
      navbar.style.maxWidth =
        "1100px";
      navbar.style.transform =
        "translateX(-50%)";
      navbar.style.zIndex =
        "9999";
      navbar.style.transition =
        "all 0.35s ease";
    }

    window.addEventListener(
      "scroll",
      handleScroll
    );

    return () => {
      window.removeEventListener(
        "scroll",
        handleScroll
      );

      if (navbar) {
        navbar.style.transform =
          "translateX(-50%) translateY(0)";
        navbar.style.opacity =
          "1";
      }
    };
  }, []);

  /* ================= CLICK GRADE ================= */

  const handleSelectGrade = (
    grade
  ) => {
    localStorage.setItem(
      "selected_grade",
      grade.grade_id
    );

    localStorage.setItem(
      "flow_type",
      flowType
    );

    if (
      Number(
        grade.has_stream
      ) === 1
    ) {
      navigate(
        `/stream/${grade.grade_id}`,
        {
          state: {
            type: flowType,
          },
        }
      );
    } else {
      navigate(
        `/${flowType}/grade/${grade.grade_id}`,
        {
          state: {
            type: flowType,
          },
        }
      );
    }

    };

  return (
    <div className="mcq-page">
      <h2 className="mcq-title">
        Select Grade
      </h2>

      {loading && (
        <p
          style={{
            color: "#fff",
          }}
        >
          Loading grades...
        </p>
      )}

      {!loading && (
        <div className="card-grid">
          {grades.map(
            (grade) => (
              <Card
                key={
                  grade.id
                }
                title={
                  grade.name
                }
                subtitle="Select Grade"
                avatarText="G"
                onClick={() =>
                  handleSelectGrade(
                    grade
                  )
                }
              />
            )
          )}
        </div>
      )}


    </div>
  );
}

export default GradePage;

